import { render, staticRenderFns } from "./Step2Detail.vue?vue&type=template&id=410fd858&scoped=true"
import script from "./Step2Detail.vue?vue&type=script&lang=js"
export * from "./Step2Detail.vue?vue&type=script&lang=js"
import style0 from "./Step2Detail.vue?vue&type=style&index=0&id=410fd858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410fd858",
  null
  
)

export default component.exports